import { useState } from "react";
import { faqItems } from "@/mocks/home";

const principles = [
  {
    icon: "ri-eye-off-line",
    title: "只讲状态，不碰八卦",
    desc: "画面聚焦穿搭与氛围，不做可识别特写，也不关联任何个人身份信息。",
  },
  {
    icon: "ri-shield-check-line",
    title: "路人视角直出",
    desc: "弱化摆拍与磨皮，真实状态和瑕疵都保留，供日常搭配参考。",
  },
  {
    icon: "ri-24-hours-line",
    title: "每日早 7:00 更新",
    desc: "街拍照片按工作日与周末双轨持续上新，想看真实状态来这就对了。",
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="border-t border-background-200/70 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex scroll-mt-24 flex-col gap-3 md:mb-10 md:flex-row md:items-end md:justify-between" id="faq">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-widest2 text-accent-700">
              <span className="font-heading text-base">05</span>
              <span className="h-px w-6 bg-accent-500" />
            </p>
            <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              看图前，先听听我们的原则
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-500 md:text-right">
            这份信任感，比任何一张好看的照片都更重要。
          </p>
        </div>

        {/* 信任区 */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {principles.map((p) => (
            <div
              key={p.title}
              className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6"
            >
              <span className="grid h-11 w-11 place-items-center rounded-md bg-accent-100 text-accent-800">
                <i className={`${p.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
            </div>
          ))}
        </div>

        {/* FAQ - 醒目 */}
        <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-4">
            <div className="rounded-lg bg-primary-500 p-6 text-background-50 md:p-7 dark:text-foreground-950">
              <p className="flex items-center gap-2 text-sm font-semibold uppercase tracking-widest2">
                <i className="ri-questionnaire-line" /> FAQ
              </p>
              <h3 className="mt-3 font-heading text-2xl font-bold leading-snug">
                你常问的，都在这里
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-background-50/85 dark:text-foreground-950/80">
                关于更新节奏、栏目区别与图片使用，一次讲清楚。若还有疑问，可前往编辑组留言。
              </p>
            </div>
          </div>

          <div className="space-y-3 lg:col-span-8">
            {faqItems.map((f, i) => {
              const open = openIdx === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-lg border transition-colors ${
                    open ? "border-primary-300 bg-background-100" : "border-background-200 bg-background-100/50"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? null : i)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-heading text-[15px] font-bold text-foreground-950 md:text-base">
                      {f.q}
                    </span>
                    <span
                      className={`grid h-7 w-7 shrink-0 place-items-center rounded-full transition-all ${
                        open ? "bg-primary-500 text-background-50 dark:text-foreground-950" : "bg-background-50 text-foreground-500"
                      }`}
                    >
                      <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-base`} />
                    </span>
                  </button>
                  {open && (
                    <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}